import { Link } from 'react-router-dom';
import { SlotFleetLogo } from './data';

export const FooterSection = () => (
  <footer className="border-t border-amber-500/10 bg-black">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <SlotFleetLogo className="w-10 h-10" />
            <div>
              <span className="text-xl font-bold text-amber-400">Slot</span>
              <span className="text-xl font-bold text-white">Fleet</span>
            </div>
          </Link>
          <p className="text-gray-400 text-sm">
            The complete platform for skill games management.
          </p>
        </div>

        <div>
          <h3 className="font-semibold mb-4 text-base">Product</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><a href="#features" className="hover:text-amber-400 transition-colors">Features</a></li>
            <li><a href="#pricing" className="hover:text-amber-400 transition-colors">Pricing</a></li>
            <li><a href="#testimonials" className="hover:text-amber-400 transition-colors">Testimonials</a></li>
            <li><a href="#faq" className="hover:text-amber-400 transition-colors">FAQ</a></li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold mb-4 text-base">Company</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><a href="#about" className="hover:text-amber-400 transition-colors">About</a></li>
            <li><a href="#careers" className="hover:text-amber-400 transition-colors">Careers</a></li>
            <li><a href="#contact" className="hover:text-amber-400 transition-colors">Contact</a></li>
            <li><Link to="/blog" className="hover:text-amber-400 transition-colors">Blog</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold mb-4 text-base">Legal</h3>
          <ul className="space-y-2 text-gray-400 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-amber-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" className="hover:text-amber-400 transition-colors">Terms of Service</Link></li>
            <li><Link to="/cookies" className="hover:text-amber-400 transition-colors">Cookie Policy</Link></li>
            <li><Link to="/data-processing-agreement" className="hover:text-amber-400 transition-colors">Data Processing</Link></li>
            <li><button onClick={() => { localStorage.removeItem('cookie_consent'); window.location.reload(); }} className="hover:text-amber-400 transition-colors">Cookie Settings</button></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-400 text-sm">
          © 2026 SlotFleet. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-gray-400 text-sm">
          <span>Made for amusement games operators</span>
        </div>
      </div>
    </div>
  </footer>
);
